import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { EnhancedNavItemBlueprint } from '@ipen-portal/plugin-common-react';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { approvalApiRef } from './apis';
import { ApprovalButton } from './components/ApprovalButton';

const overviewRouteRef = createRouteRef();

const ApprovalScaffolder = PageBlueprint.make({
  name: 'ApprovalScaffolder',
  params: {
    loader: async () =>
      import('@backstage/plugin-scaffolder').then(m => (
        <m.ScaffolderPage
          headerOptions={{
            pageTitleOverride: 'Create a new approval request',
            subtitle:
              'Create new request for deciding on approvals in your process.',
            title: 'Create a new approval request',
          }}
        />
      )),
    noHeader: true,
    path: '/approvals/create',
  },
});

const ApprovalNavEntry = EnhancedNavItemBlueprint.make({
  attachTo: { id: 'app/nav', input: 'items' },
  params: {
    featureFlag: 'approvals',
    icon: ApprovalButton,
    skipIconWrapping: true,
    target: '/approvals',
    title: 'Approvals',
  },
});

const ApprovalPage = PageBlueprint.make({
  name: 'ApprovalPage',
  params: {
    loader: () =>
      import('./components/ApprovalPage').then(m => <m.ApprovalPage />),
    noHeader: true,
    path: '/approvals',
    routeRef: overviewRouteRef,
  },
});

const ApprovalTemplateListPage = PageBlueprint.make({
  name: 'ApprovalTemplateListPage',
  params: {
    loader: () =>
      import('./components/ApprovalTemplateList').then(m => (
        <m.ApprovalTemplateListPage />
      )),
    noHeader: true,
    path: '/approvals/templates',
  },
});

const ApprovalApi = TrpcApiBlueprint.make({
  name: 'approval-api',
  params: defineParams =>
    defineParams({
      apiRef: approvalApiRef,
      path: 'approval',
    }),
});

export const approvalPlugin = createFrontendPlugin({
  extensions: [
    ApprovalScaffolder,
    ApprovalApi,
    ApprovalPage,
    ApprovalTemplateListPage,
    ApprovalNavEntry,
  ],
  featureFlags: [{ name: 'approvals' }],
  pluginId: 'approval',
  routes: {
    overview: overviewRouteRef,
  },
});
